import contents from '../../api/contents';
import * as types from '../mutation-types';

const state = {
  contents: [],
  search: null
};

const getters = {
  Contents: state => state.contents,
  ContentsSearch: state => state.search
};

const actions = {
  getContents: ({ commit, state }) => {
    contents.getContents(state.search).then(response => {
      commit(types.SET_CONTENTS, response.data);
    });
  },

  getContent: ({ commit }, id) => {
    contents.getContent(id).then(response => {
      commit(types.SET_CONTENTS, response.data);
    });
  },

  setContentsSearch: ({ commit }, search) => {
    commit(types.SET_CONTENT_SEARCH, search);
  }
};

const mutations = {
  [types.SET_CONTENTS](state, contents) {
    state.contents = contents;
  },

  [types.SET_CONTENT_SEARCH](state, search) {
    state.search = search;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
